import { createFileRoute } from "@tanstack/react-router";

import { ActionItemsPage } from "../../pages/dashboard/action-items/ActionItems.page";
import { searchForView } from "../../pages/dashboard/action-items/search";

/**
 * The sidebar's saved views.
 *
 * Kept as a path so existing links and bookmarks resolve, but the view no
 * longer owns any state: `validateSearch` seeds the equivalent search params
 * and the page reads those, so a view is a starting point the user can then
 * change — and the change sticks, because it lives in the URL.
 */
export const Route = createFileRoute("/_protected/action-items/$view")({
  validateSearch: (search: Record<string, unknown>) => search,
  component: ActionItemsViewRoute,
});

function ActionItemsViewRoute() {
  const { view } = Route.useParams();
  const rawSearch = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ActionItemsPage
      search={searchForView(view, rawSearch)}
      onSearchChange={(next) =>
        void navigate({ search: { ...next }, replace: true })
      }
    />
  );
}
